export default "__VITE_ASSET__c6tDm1si__"